const PlaceholderManagementType = {
  CATEGORY2: 'CATEGORY2',
  RESET: 'RESET',
  YEARSDATA: 'YEARSDATA',
};

export default PlaceholderManagementType;
